export default __webpack_public_path__ + "static/media/legumbres.a7521fb5.svg";